.textInput {
    composes: textInput from "../../styles/composable/form-fields.module.css";
}

.label {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    display: block;
    font: var(--font-eyebrow-14, var(--font-eyebrow));
    line-height: 1.3;
    margin-bottom: var(--spacer-4);
    color: var(--form-label-color);
}

.required::after {
    content: "*";
}

.description {
    display: block;
    margin-top: var(--spacer-4);
    font: var(--font-p-14);
}

.errorMessage {
    composes: description;
    color: var(--accent, var(--red));
}

.formButton {
    composes: buttonReset from "../../styles/composable/utility.module.css";
    composes: textInput from "../../styles/composable/form-fields.module.css";
    position: relative;
    width: 100%;
    background-color: var(--white);
    color: var(--medium-gray);
    text-align: left;
}

.downArrow {
    position: absolute;
    top: 50%;
    right: var(--spacer-8);
    translate: 0 -50%;
    rotate: 90deg;
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: currentColor;
}

.popover {
    background-color: var(--white);
    border: 2px solid var(--light-gray);
    font: var(--font-p-16);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    [data-design-version="v2026"] & {
        background-color: var(--off-white);
        border: 1px solid var(--gray-300);
    }

    &[data-trigger="Select"] {
        width: var(--trigger-width);
    }
}

.listBox {
    &:focus {
        outline: none;
    }
}

.listBoxItem {
    padding: var(--spacer-8);
    cursor: pointer;

    &:focus {
        outline: none;
    }
}

.focusedListBoxItem {
    background-color: var(--off-white);

    [data-design-version="v2026"] & {
        background-color: var(--gray-100);
    }
}

.selectedListBoxItem {
    font-weight: 700;
}

.dateInput {
    composes: textInput from "../../styles/composable/form-fields.module.css";
    display: flex;
}

.autocompletePopover {
    width: 300px;
    max-width: 100%;
    background-color: var(--white);
    border: 1px solid var(--light-gray);
    font: var(--font-p-16);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.autocompleteListBoxItem {
    padding: var(--spacer-16);
    border-bottom: 1px solid var(--gray);
    cursor: pointer;

    &:focus {
        outline: none;
    }
}

.autocompleteListBoxItemFocused {
    background-color: var(--off-white);
}

.autocompleteListBoxItemSelected {
    font-weight: 700;
}

.fileUploadRoot {
    composes: textInput;
}

.fileList {
    composes: listReset from "../../styles/composable/utility.module.css";
    margin-top: var(--spacer-8);
    display: flex;
    flex-direction: column;
    gap: var(--spacer-4);
}

.fileListItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacer-8);
    background-color: var(--off-white);
    border: 1px solid var(--light-gray);
}

.fileRemoveButton {
    composes: buttonReset from "../../styles/composable/utility.module.css";
    width: var(--spacer-24);
    height: var(--spacer-24);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: var(--spacer-20);
    color: var(--medium-gray);

    &:hover {
        color: var(--red);
    }
}
